import { getExpiryDays } from "../../../services/usersManagementService";

/**
 * Estilos semánticos para alertas de vencimiento según días restantes y estado.
 */
export const getExpiryAlertStyles = (user) => {
  const days = getExpiryDays(user.expiryDate);
  let bg = "background.paper";
  let border = "grey.300";
  let color = "text.secondary";
  let indicator = "grey.500";

  if (days <= 0 || user.status === "Vencido") {
    bg = "error.lighter";
    border = "error.light";
    color = "error.dark";
    indicator = "error.main";
  } else if (days <= 7) {
    bg = "error.light";
    border = "error.main";
    color = "error.dark";
    indicator = "error.main";
  } else if (days <= 15) {
    bg = "warning.light";
    border = "warning.main";
    color = "warning.dark";
    indicator = "warning.main";
  } else if (days <= 30) {
    bg = "success.light";
    border = "success.main";
    color = "success.dark";
    indicator = "success.main";
  }

  return { bg, border, color, indicator, days };
};
